import { P2GDate } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { BookingDetails } from '~/lib/api/smartsend/types';
import { RoyalMailProvider } from '~/lib/consts/providers';

interface props {
  bookingDetails: BookingDetails;
  variant?: 'body2' | 'caption';
  wrapper: (content: React.ReactNode) => React.ReactNode;
}

export default function ItemEstimatedCollectionDate(props: props) {
  if (
    !props.bookingDetails ||
    !props.bookingDetails.EstimatedCollectionDate ||
    props.bookingDetails.Service?.Provider != RoyalMailProvider
  ) {
    return null;
  }

  return props.wrapper(
    <P2GText variant={props.variant}>
      Dispatch: <P2GDate variant={props.variant} date={new Date(props.bookingDetails.EstimatedCollectionDate)} />
    </P2GText>
  );
}
